// I18nProvider — STUB.
//
// Реальный провайдер (с конфигом react-i18next + ICU plugin + загрузкой
// locale namespaces) создаётся i18n-агентом в отдельном PR. Этот файл
// существует, чтобы AppProviders можно было собрать уже сейчас.
//
// Если i18n-агент создал реальный i18nInstance, нужно импортнуть его и
// обернуть `<I18nextProvider i18n={i18nInstance}>`. Пока что — pass-through.
import type { ReactNode } from "react";

export function I18nProvider({ children }: { children: ReactNode }) {
	return <>{children}</>;
}
